// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

const TAG_BASE_URL = '/api/v1/wechat/tag';

/**
 * 获取标签列表
 * @param options 请求配置
 */
export async function getTagList(options?: { [key: string]: any }) {
  return request<OA.ApiResponse<OA.TagListData>>(`${TAG_BASE_URL}/list`, {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 创建标签
 * @param data 标签数据
 * @param options 请求配置
 */
export async function createTag(
  data: OA.CreateTagParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.CreateTagResult>>(`${TAG_BASE_URL}/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 更新标签
 * @param data 标签数据
 * @param options 请求配置
 */
export async function updateTag(
  data: OA.UpdateTagParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.UpdateTagResult>>(`${TAG_BASE_URL}/update`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除标签
 * @param tagid 标签ID
 * @param options 请求配置
 */
export async function deleteTag(tagid: number, options?: { [key: string]: any }) {
  return request<OA.ApiResponse<OA.DeleteTagResult>>(`${TAG_BASE_URL}/delete`, {
    method: 'DELETE',
    params: { tagid },
    ...(options || {}),
  });
}

/**
 * 获取标签成员
 * @param tagid 标签ID
 * @param options 请求配置
 */
export async function getTagUsers(tagid: number, options?: { [key: string]: any }) {
  return request<OA.ApiResponse<OA.TagUsersData>>(`${TAG_BASE_URL}/users`, {
    method: 'GET',
    params: { tagid },
    ...(options || {}),
  });
}

/**
 * 添加标签成员
 * @param data 标签成员数据
 * @param options 请求配置
 */
export async function addTagUsers(
  data: OA.AddTagUsersParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.AddTagUsersResult>>(`${TAG_BASE_URL}/users/add`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除标签成员
 * @param data 标签成员数据
 * @param options 请求配置
 */
export async function deleteTagUsers(
  data: OA.DeleteTagUsersParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.DeleteTagUsersResult>>(`${TAG_BASE_URL}/users/delete`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

